import { render } from "./update_email.vue?vue&type=template&id=28c9314e"
import script from "./update_email.vue?vue&type=script&lang=js"
export * from "./update_email.vue?vue&type=script&lang=js"

import "./update_email.vue?vue&type=style&index=0&id=28c9314e&lang=css"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__